import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import BigCard from "../../../general/BigCard";
import Slider from "../../../general/Slider";
import SmallPieGraph from "../../../general/SmallPieGraph";
import Table from "../../../general/Table";
import styles from "./ProdutionPageL1.module.css";

function ProdutionPageL1({
  distrito,
  menuFilterParams,
  handles,
  searchControl,
  setNaturezaImage,
}) {
  const [propCadastrada, setPropCadastradas] = useState(null);
  const [areaMaxima, setAreaMaxima] = useState(null);
  const [producaoMaxima, setProdMaxima] = useState(null);
  const [naturezaProd, setNaturezaProd] = useState(null);
  const [contarProducao, setContarProducao] = useState(null);
  const [sliderMinArea, setSliderMinArea] = useState(0.0);
  const [sliderMaxArea, setSliderMaxArea] = useState(40000.0);
  const [sliderMinProd, setSliderMinProd] = useState(0.0);
  const [sliderMaxProd, setSliderMaxProd] = useState(10000000.0);

  const {handleAreaMin, handleAreaMax, handleProdMin, handleProdMax} = handles;
  const {selectedOption, searchInput} = searchControl;
  const {category, subcategoria, natureza} = menuFilterParams;

  const inscricao = Functions.getInscricaoParam(selectedOption, searchInput);
  const proprietario = Functions.getProprietarioParam(
    selectedOption,
    searchInput
  );

  useEffect(() => {
    const fetchMaxValues = async () => {
      try {
        const [areaMaxima, producaoMaxima] = await Promise.all([
          Api.getAreaMaxima(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario
          ),
          Api.getProdMaxima(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario
          ),
        ]);
        setAreaMaxima(areaMaxima);
        setProdMaxima(producaoMaxima);
        setSliderMaxArea(areaMaxima?.value ?? 0.0);
        setSliderMaxProd(producaoMaxima?.value ?? 0.0);
      } catch (error) {
        console.error("Erro ao buscar máximos:", error);
      }
    };

    fetchMaxValues();
  }, [distrito, category, subcategoria, natureza, inscricao, proprietario]);

  useEffect(() => {
    const fetchFilteredData = async () => {
      try {
        const [propCadastrada, naturezaProd, contarProducao] =
          await Promise.all([
            Api.getNumeroPropriedades(
              distrito,
              category,
              subcategoria,
              natureza,
              inscricao,
              proprietario,
              sliderMinArea,
              sliderMaxArea,
              sliderMinProd,
              sliderMaxProd
            ),
            Api.getNaturezaProd(
              distrito,
              category,
              subcategoria,
              natureza,
              inscricao,
              proprietario,
              sliderMinArea,
              sliderMaxArea,
              sliderMinProd,
              sliderMaxProd
            ),
            Api.getContarProducao(
              distrito,
              category,
              subcategoria,
              natureza,
              inscricao,
              proprietario,
              sliderMinArea,
              sliderMaxArea,
              sliderMinProd,
              sliderMaxProd
            ),
          ]);
        setPropCadastradas(propCadastrada);
        setNaturezaProd(naturezaProd);
        setContarProducao(contarProducao);
      } catch (error) {
        console.error("Erro ao buscar dados filtrados:", error);
      }
    };

    fetchFilteredData();
  }, [
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    sliderMinArea,
    sliderMaxArea,
    sliderMinProd,
    sliderMaxProd,
  ]);

  const handleSliderMinArea = (value) => {
    setSliderMinArea(value);
    handleAreaMin(value);
  };

  const handleSliderMaxArea = (value) => {
    setSliderMaxArea(value);
    handleAreaMax(value);
  };

  const handleSliderMinProd = (value) => {
    setSliderMinProd(value);
    handleProdMin(value);
  };

  const handleSliderMaxProd = (value) => {
    setSliderMaxProd(value);
    handleProdMax(value);
  };

  return (
    <div className={styles.produtionPageL1}>
      <div className={styles.bigCard}>
        <BigCard
          name="PROPRIEDADES CADASTRADAS: "
          value={propCadastrada?.value ?? "..."}
        />
      </div>
      <div className={styles.graphSliders}>
        <div className={styles.smallPieGraph}>
          {category && (
            <SmallPieGraph
              text="Natureza da produção"
              onImageReady={setNaturezaImage}
              data={Functions.buildSmallPieGraphParams(naturezaProd)}
            />
          )}
        </div>

        <div className={styles.slider}>
          <Slider
            name="Área (ha)"
            maxLimit={areaMaxima?.value ?? 0.0}
            minValue={sliderMinArea}
            maxValue={sliderMaxArea}
            onSliderMinChanged={handleSliderMinArea}
            onSliderMaxChanged={handleSliderMaxArea}
          />

          <Slider
            name="Produção"
            maxLimit={producaoMaxima?.value ?? 0.0}
            minValue={sliderMinProd}
            maxValue={sliderMaxProd}
            onSliderMinChanged={handleSliderMinProd}
            onSliderMaxChanged={handleSliderMaxProd}
          />
        </div>
      </div>

      <div className={styles.table}>
        <div className={styles.tableContent}>
          <Table data={contarProducao ?? []} />
        </div>
      </div>
    </div>
  );
}

export default ProdutionPageL1;
